import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ModalidadPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ModalidadPage",
            ss: ss,
            ajax: {
                "url": ss.indexModalidad(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Modalidad', name: 'Modalidad', title: 'Modalidad' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            modalidades: [],
            modalidad: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newModalidad() {
            this.modalidad = {};
            this.$refs['frm-modalidad'].show();
        },
        showModalidad(id) {
            this.isLoading=true;
            this.ss.showModalidad(id).then(
                (result) => {
                    let response = result.data;
                    this.modalidad = response.data;
                    this.$refs['view-modalidad'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editModalidad() {
            this.$refs['frm-modalidad'].show();
            this.$refs['view-modalidad'].hide();
        },
        cancelModalidad() {
            if (this.modalidad.id) {
                this.$refs['view-modalidad'].show();
            }
            this.$refs['frm-modalidad'].hide();
        },
        saveModalidad() {
            this.ss.storeModalidad(this.modalidad).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-modalidad'].hide();
                    this.$refs['datatable-modalidad'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteModalidad() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyModalidad(this.modalidad)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-modalidad'].hide();
                                this.$refs['datatable-modalidad'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Modalidad').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showModalidad(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
